<div class="menu-banner-card">
  <div class="menu-banner-image" style.background-image="url('{{ imageUrl() }}')" [style.height.px]="imageHeight()"></div>
  <div class="menu-banner-content">
    <h2 class="menu-banner-title">{{ title() }}</h2>
    <p class="menu-banner-description">{{ description() }}</p>
    <div class="menu-banner-button-container">
      @if (buttonHref()) {
        @if (internalLink()) {
          <a class="menu-banner-url" [routerLink]="buttonHref()" [queryParams]="queryParams()" (click)="triggerAction($event)">{{ buttonLabel() }}</a>
        } @else {
          <a class="menu-banner-url" [href]="buttonHref()" target="_blank" rel="noopener noreferrer" (click)="triggerAction($event)">{{ buttonLabel() }}</a>
        }
      } @else {
        <a class="menu-banner-url" [href]="bannerUrl()" target="_blank" rel="noopener noreferrer" (click)="triggerAction($event)">{{ buttonLabel() }}</a>
      }
    </div>
  </div>
</div>
